export const generateRoleBasePath = (role: string, path: string) => {
  return `/${role || ''}/${path}`.replaceAll('//', '/');
};
